
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexZqETSncS5p18OImNbFrMUJ4kwmNgeedjgS7dYE3czBsMeta } from "/codebuild/output/src3150998498/src/pages/index.vue?macro=true";
import { default as indexKH1UU_45m9OiYTHlD58SaAEY9ltfY01P_Cb2H16_45kvuIYMeta } from "/codebuild/output/src3150998498/src/pages/login/index.vue?macro=true";
import { default as indexXy9kXr8vLqf3zcLyz8L5YXK_45eT_O7Fycif_bTPPJEWwMeta } from "/codebuild/output/src3150998498/src/pages/software/index.vue?macro=true";
import { default as indexJE54SKD_Mf6lXYcp_45YPijIH7gz0krUvn9tsPPig05YYMeta } from "/codebuild/output/src3150998498/src/pages/trackers/index.vue?macro=true";
import { default as indexCgsLjVnrVjzb3i56sCQqqS4kWOcUFDtuQFBkQLkNKnMMeta } from "/codebuild/output/src3150998498/src/pages/templates/index.vue?macro=true";
import { default as createstBVr4lKa1wQKf9EpCmJQbWJXkizt5yPsliXasdTBBsMeta } from "/codebuild/output/src3150998498/src/pages/trackers/create.vue?macro=true";
import { default as createUZ81aUDPnbX_45CYyOlG22hj4wbO1Q96qtTvENRitlraAMeta } from "/codebuild/output/src3150998498/src/pages/templates/create.vue?macro=true";
import { default as indexXVSzu65sXPxMuD2SAF9YO9jKIgvWotYj6sIkgDSnG4UMeta } from "/codebuild/output/src3150998498/src/pages/tagging-docs/index.vue?macro=true";
import { default as editKGdVKqMZlkoamcoRtzZPuBLXXJ8qL1nrCFCl1DGN3f0Meta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93F2j9wFa_45rXnHPS7NwRdshDqnXYCkIViw_45_45GjCpWJzTMMeta } from "/codebuild/output/src3150998498/src/pages/login/token/[token].vue?macro=true";
import { default as edit5Riz6kANr4dUlYOo7yH_0uCJnatv0JrZtRwblZ52nP4Meta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexkD4xrcPiEwkrO23l42KPzXMi3VuptEC0BJXZ_9xThw4Meta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/index.vue?macro=true";
import { default as indexQPsvZ9lFvSWrvs1ca4F3cT5ygLH1n9oDbu9hxpRYIiYMeta } from "/codebuild/output/src3150998498/src/pages/plan-management/index.vue?macro=true";
import { default as indexvLJSVU_LLjbKKZOoKLX1USAZaFvenJQY5YjE9qQGtigMeta } from "/codebuild/output/src3150998498/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexsFd1OLaBVNnLJReA0hrjJxL8tZ07nOLnbw4gcBJTVi0Meta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexJ3gayXFGEbLbXM0woevSrcGwx0CM6nvBV0Gs4hMCA8QMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexSvuGlIYW4jcgFeGR62fvMTAb91UYjLZUr7QD5Xz9LjgMeta } from "/codebuild/output/src3150998498/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createOcHYCQggJRZ_45ypIyzUbLxqjT8M2B9Zas3bBOF4HIeQwMeta } from "/codebuild/output/src3150998498/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editiW9Ua3EGVYU9NGqVr2To92Oy06Au861MPBpfHo8_45AnEMeta } from "/codebuild/output/src3150998498/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsLmp71yiC_45i9HY5Soxp8K6k0oHvX_45dnHzXOn3H8tsXzkMeta } from "/codebuild/output/src3150998498/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexE9xtJgMYUWdsZRNtQXJiMISyNKxWFGgXA8l71iKEEccMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createSxxC_vyMiFBoKCuxrpHX8xp1MEUGzN0vpAlivukvyjYMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groups3D0dPs76fF5QMnaXKpLLJ1qk7Icd_454g8ue21WyrVCT4Meta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createdUQ6z4UUb9_45RCiWiXLfUWyuYz3G4BtJ25SVXdXIs66oMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indexM5R6gjdOErucL_45jdkAa9ySbtNkqKaNGHShA75OytYgIMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexMhv8gfo_4586U81yfSbwnO9w0PC2T3z7h24AHRw4ahjPIMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createXB4dUZr9tIUXBSsxoS9GGX88urC6QkeQ3aF_45fgltB1QMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backend11hDzrsUToMfitdgf0EgSKEBnCr7mI6Kb07s7MA276MMeta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createT89Av_45pU_45TzGaT6qn1EHdDXsm3YcvtL7kcpgBiqi5PgMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendMzsjhqHB6BpOj_c8Yq_45ZW1she35Uep_45MxhEPMRxL2h8Meta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePagecG20ZnqHbu3BK80e9NjqYQALKa6ZfQvez8XfVeAqlr4Meta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as index3tbbon2nrwKKbkMNvaResK1c0it56DZTV_45NDHIMZzuQMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as indexNI7kIdgL6cTNJ_45Zhw9RDVS1kZHht5R9RnmKzGtT_ZZ4Meta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershipLHYpBiAxWKBPqDz8vh4fPlwpdJfLhWlfk9Yn4TgvepgMeta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as indexKkTrfrI3JAp3tB1H_45k1w2AJl8T7ZSGTfqug5c2hDcJUMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as indexyQyEjjTjxWEkUQgDmwntpMYwH_gl8bgS18BInnBrstUMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendBQrlSZgiVje1GZiXyEr7ojRpKN3jZzAJek_z8LpOa08Meta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2QwOzE__45qM2lvjiqvkrsUGjZWoukJL_45Y8_nFUEK_dsX8Meta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as editfJhTknYF1AaZ50TQT2gL_18vERsjyjv_pjrBOh2wl3MMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as edit2xo3NPZvgtK937ALkp0JOB0l0Ju3t9FG8zpMGhGA7FUMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsSeCvDoWm8n_A7kS5HB74rhVRZZ4OG34tYsuq0iBlhAQMeta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45saless0OOXZ50rX8u7O2LCuwwgh_45cSytUw2ZTkgWa87tiorsMeta } from "/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as index5aJ8ZesaHa5xJGrVCfwwrGt4IiN59Kh_45a_45tCprtlE7kMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexlCmMlkPBAe49EqlZgVg8OcVkpBa_D5E_zF1UOVkfSO8Meta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createu0aVD3OecUjaFTtVgbnRZ5K7FgYZUeNTiCJ4Yumjy60Meta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as create7czYl9OWwNk4MX_9RzdnuNskLOkCENE1vcJvijroliMMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editO6UR7a6_45ZgUooUUFsZp7mC8xEkrNEn5R0Q1d9mfu4qgMeta } from "/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editLTpRxS_45wBxgtBVkuDpuKVwShqnGujSUvLnHtE3OzDJEMeta } from "/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3150998498/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src3150998498/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src3150998498/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src3150998498/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src3150998498/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src3150998498/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src3150998498/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsLmp71yiC_45i9HY5Soxp8K6k0oHvX_45dnHzXOn3H8tsXzkMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src3150998498/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src3150998498/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src3150998498/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src3150998498/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3150998498/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]